import { Component, Element, h, Prop } from '@stencil/core';
import { LinkTarget } from '../../../types';
import { generateCssClasses } from '../../../utils/generate-css-classes';
import { hasSlotted } from '../../../utils/slotted';

@Component({
	shadow: true,
	styleUrl: 'zds-navigation-panel-link.scss',
	tag: 'zds-navigation-panel-link',
})
export class ZdsNavigationPanelLink {
	@Element() hostElement: HTMLDivElement;

	@Prop({ reflect: true }) level: number = 1;
	@Prop() link: string;
	@Prop() linkTarget: LinkTarget = '_self';

	renderIcon() {
		if (!hasSlotted(this.hostElement, 'icon')) {
			return null;
		}

		return (
			<div class="zds-navigation-panel-link__icon">
				<slot name="icon"></slot>
			</div>
		);
	}

	render() {
		const cssClasses = generateCssClasses('zds-navigation-panel-link', {
			[`level-${this.level}`]: true,
		});

		return (
			<a class={cssClasses} href={this.link} target={this.linkTarget} aria-level={this.level} role="link">
				{this.renderIcon()}
				<slot />
			</a>
		);
	}
}
